module.exports = __webpack_public_path__ + "static/media/thumbs.e17fc96b.png";